import { Language } from './types';

const BASE_LANGUAGE_LABELS = {
  regMxTitle: "Your company's address",
  regMxPost: 'Zip code',
  regMxPostLink: "Don't know your zip code?",
  fileInputAlert:
    'This document must be in the name of your company and not older than 3 months.',
  regMxColony: 'Colony',
  regMxSector:
    'Occupation, profession, activity or line of business (Please type in Spanish)',
  ergMxSearchByKeyWord: 'Search by keyword',
  regMxDocTax: 'Document of latest fiscal status',
  regMxDocRPC: 'Registration to the RPC (Public Registry of Commerce)',
  regMxDocAEC: 'Proof of the FIEL (Advanced Electronic Signature)',
  regMxDocRep: 'Legal representative powers',
  regMxDocRepId:
    'Scanned and colored identification of the legal representative',
  regMxSeeExample: 'See example',
  regMxFielTitle: 'Example of the FIEL certificate',
  proofOfAddressDoc: 'Proof of address',
  usaDocPassport: 'Passport',
  usaDocPersonalId: 'Personal ID',
  usaDocPersonalIdBack: 'Personal ID back',
  usaFrontDocument: 'front',
  usaDocDriversLicence: "Driver's licence",
  usaDocDriversLicenceBack: "Driver's licence back",
  onbRegistrycompanyDocumentType: 'Document type',
  onbRegistryindustryCode: 'Industry Code',
  onbEffectiveDate: 'Effective date',
  onbExpiryDate: 'Expiry date',
  onbGender: 'Gender',
  onbNumber: 'Number',
};

type LabelsLanguage = keyof typeof BASE_LANGUAGE_LABELS;

const REGISTER_MEXICO_LANGUAGE_LABELS: Record<
  Language,
  Record<LabelsLanguage, string | object>
> = {
  EN: BASE_LANGUAGE_LABELS,
  ES: {
    regMxTitle: 'Dirección de tu empresa',
    regMxPost: 'Código postal',
    regMxPostLink: '¿No sabes tu código postal?',
    fileInputAlert:
      'Este comprobante debe estar a nombre de tu empresa y no ser mayor a 3 meses de antigüedad.',
    regMxColony: 'Colonia',
    regMxSector: 'Ocupación, profesión, actividad o giro',
    ergMxSearchByKeyWord: 'Buscar por palabra clave',
    regMxDocTax: 'Cédula de situación fiscal',
    regMxDocRPC: 'Registro ante el RPC (Registro Público de Comercio)',
    regMxDocAEC: 'Constancia de la FIEL (Firma Electrónica Avanzada)',
    regMxSeeExample: 'Ver ejemplo',
    regMxDocRep: 'Poderes del representante legal',
    regMxDocRepId: 'Identificación del representante legal escaneada y a color',
    regMxFielTitle: 'Ejemplo constancia de la FIEL',
    proofOfAddressDoc: 'Comprobante de domicilio',
    usaDocPassport: 'Pasaporte',
    usaDocPersonalId: 'Identificación personal',
    usaDocPersonalIdBack: 'Identificación personal reverso',
    usaFrontDocument: 'frontal',
    usaDocDriversLicence: 'Licencia de conducir',
    usaDocDriversLicenceBack: 'Licencia de conducir reverso',
    onbRegistrycompanyDocumentType: 'Tipo de documento',
    onbRegistryindustryCode: 'Código de la Industria',
    onbEffectiveDate: 'Válido desde',
    onbExpiryDate: 'Fecha de expiración',
    onbGender: 'Género',
    onbNumber: 'Número',
  },
};

export default REGISTER_MEXICO_LANGUAGE_LABELS;
